import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const submitOrderForUnderwritingActions = createDataModuleActions(
    'SUBMIT_ORDER_FOR_UNDERWRITING',
);

export const submitOrderForUnderwriting =
    submitOrderForUnderwritingActions.dataRequest;
export const submitOrderForUnderwritingSuccess =
    submitOrderForUnderwritingActions.dataSuccess;
export const submitOrderForUnderwritingError =
    submitOrderForUnderwritingActions.dataError;
export const submitOrderForUnderwritingReset =
    submitOrderForUnderwritingActions.dataReset;
